import { cn } from "@/lib/utils";

interface PageBackgroundProps {
  children: React.ReactNode;
  className?: string;
}

export function PageBackground({ children, className }: PageBackgroundProps) {
  return (
    <div
      className={cn(
        "relative -mx-4 md:-mx-6 -mt-4 px-4 md:px-6 pt-4 bg-muted/50 dark:bg-muted/30 min-h-screen",
        className,
      )}
      style={{
        backgroundImage: "url('/background/ffflux.svg')",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="absolute inset-0 pointer-events-none dark:bg-muted/90" />
      <div
        className="absolute bottom-0 left-0 right-0 h-64 pointer-events-none z-10"
        style={{
          background:
            "linear-gradient(to bottom, transparent 0%, var(--background) 100%)",
        }}
      />
      <div className="relative z-20">{children}</div>
    </div>
  );
}
